import { render, staticRenderFns } from "./dialog-bet-online.vue?vue&type=template&id=a9fe309c"
import script from "./dialog-bet-online.vue?vue&type=script&lang=js"
export * from "./dialog-bet-online.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports